import { render, staticRenderFns } from "./ContribuinteVinculoCadastro.vue?vue&type=template&id=09e25904&scoped=true&"
import script from "./ContribuinteVinculoCadastro.vue?vue&type=script&lang=js&"
export * from "./ContribuinteVinculoCadastro.vue?vue&type=script&lang=js&"
import style0 from "./ContribuinteVinculoCadastro.vue?vue&type=style&index=0&id=09e25904&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e25904",
  null
  
)

export default component.exports